import './App.css';
import Sortingvisualizer from './pages/Sortingvisualizer';

function App() {
  return (
    <div className="App">
     <Sortingvisualizer></Sortingvisualizer>
    </div>
  );
}

export default App;
